import { RootState } from "@store/index";
import { createSelector } from "reselect";
import { PatientState } from "./patientSlice";

const patientState = (state: RootState) => state.patient as PatientState;

export const selectSelectedPatient = createSelector(
  [patientState],
  (state) => state.selectedPatient,
);

export const selectWorklistContext = createSelector(
  [patientState],
  (state) => state.worklistContext,
);
